export const downloadFile = (fileName: string, blob: any) => {
  const link = document.createElement("a");
  link.target = '_blank';
  link.download = fileName;
  link.href = URL.createObjectURL(blob);
  link.click();
};
